import GlobalBanner from './GlobalBanner'

export default GlobalBanner


// WEBPACK FOOTER //
// ./src/pages/GlobalBanner/index.js